<template>
    <div class="row">
        <div @click="$router.go(-1)" class=" arrow_text cursor-pointer width-100">
            <chevron-left-icon size="1.5x" class="custom-class" style="vertical-align: top;"></chevron-left-icon>
            <span class="back">Back</span>
        </div>

        <div v-if="ticket" class="col-md-6">
            <h3 class=" font-regular mb-2 mt-1">
                {{ ticket.title }}
            </h3>
            <h4 class=" font-regular mb-2 mt-1">
                <span class="text-info">Ticket Reference :</span> {{ ticket.reference }}
            </h4>
            <h4 class=" font-regular mb-2 mt-1">
                <span class="text-info">Status :</span>
                <!-- create badge -->
                <span v-if="ticket.status === 'open'" class="badge badge-success">Open</span>
                <span v-else class="badge badge-danger">Closed</span>
            </h4>


            <div class="shadow-sm rounded-2 max-width my-2">
                <p class="m-0 fw-bold text-dark">
                    {{ `${ticket.created_by_user.first_name} ${ticket.created_by_user.last_name}` }}
                </p>
                <p class="m-0">{{ ticket.body }}</p>
                <br>
                <p class="m-0 text-info text-italic">{{ ticket.created_at | date }}</p>
            </div>
            <div style="cursor: pointer" v-if="ticket.file_1" @click.prevent="
                openImageModal(ticket.file_1)
                ">
                <button class="btn btn-primary">View Image</button>
            </div>
            <div v-if="ticket.support_threads.length > 0" class="my-2 scroll-h">
                <div v-for="(item, index) in ticket.support_threads" :key="index"
                    class="shadow-sm rounded-2 max-width my-2">
                    <p class="m-0 fw-bold text-dark">
                        {{ item.created_by_user.first_name }} {{ item.created_by_user.last_name }}
                    </p>
                    <p class="m-0">{{ item.body }}</p>
                    <p class="m-0 text-info text-italic">{{ item.created_at | date }}</p>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-9">
                    <div class="form-group">
                        <label for="">Message</label>
                        <textarea name="" id="" cols="30" rows="4" class="form-control" style="resize: none"
                            v-model="body"></textarea>
                    </div>
                </div>
                <div class="col-3">
                    <div class="form-group">
                        <label for="">Status</label>
                        <select class="form-control" v-model="status">
                            <option value="" disabled selected>Please Select Status</option>
                            <option value="open">Open</option>
                            <option value="closed">Closed</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <button class="btn btn-primary" @click="createThread">
                        <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                        <span v-else>Create Thread</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import KeyValue from "../../components/KeyValue.vue";
import ApiService from "../../services/api.service";
import usersIcon from "@/assets/images/users-avatar.png";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
export default {
    props: {
        slug: {
            type: [String],
            required: true
        }
    },
    data() {
        return {
            ticket: null,
            body: "",
            status: "",
            images: [],
            loading: false,
        };
    },
    methods: {
        async getTicket() {
            try {
                const response = await ApiService.get(`ticket/get_ticket/${this.slug}`);
                this.ticket = response.data.data;
                console.log(this.ticket);
            } catch (error) {
                console.log(error);
                let _error = error.response.data;
                ErrorService.displayErrorAlert(_error);
            }
        },
        openImageModal(param) {
            this.images = [];
            this.$viewerApi({
                images: [param]
            });
            this.images.push(param);
            console.log(this.images);
            // this.photoLoading = true;
            console.log(param);
            setTimeout(() => this.setImage(param), 4000);
        },
        async createThread() {
            this.loading = true;
            try {
                const response = await ApiService.post(`ticket/create_thread`, {
                    body: this.body,
                    status: this.status,
                    support_ticket_id: this.ticket.id
                });
                this.loading = false;
                Swal.fire({
                    title: "Success",
                    text: response.data.message,
                    icon: "success",
                    confirmButtonText: "Ok"
                });
                this.getTicket();
                this.body = "";
                this.status = "";
            } catch (error) {
                console.log(error);
                let _error = error.response.data;
                this.loading = false;
                ErrorService.displayErrorAlert(_error);
            }
        },
    },
    mounted() {
        this.getTicket();
    },

}
</script>

<style scoped>
.id-file {
    width: 80%;
    height: 150px;
    border-radius: 4px;
}
</style>